import { FC } from 'react';
import { useIntl } from 'react-intl';

import { PageTitle } from '../../../_metronic/layout/core';
import { AcquisitionFunnel } from '../../modules/acquisition';

const MarketingDashboardPage: FC = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'marketingDashboard.title' })}
      </PageTitle>
      <AcquisitionFunnel />
    </>
  );
};

export { MarketingDashboardPage };
